// D:\Event\frontend\src\components\firstpage.js
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./register.css";
import logo3 from "../assets/bg.png";
import { backend_url } from "../constants/backend";

export default function FirstPage() {
  const location = useLocation();
  const [email, setEmail] = useState(""); 
  const [feedbackText, setFeedbackText] = useState("");
  const [feedbackSending, setFeedbackSending] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState("");

  // Get email internally (silently)
  useEffect(() => {
    const stateEmail = location?.state?.email;
    if (stateEmail) {
      setEmail(stateEmail);
    } else {
      try {
        const stored = sessionStorage.getItem("userEmail") || "";
        setEmail(stored);
      } catch (err) {
        console.warn("sessionStorage unavailable:", err);
      }
    }
  }, [location]);

  // 🔥 UPDATED — Replace submitFeedbackApi with fetch(backend_url + "/submit-feedback/")
  const handleSubmitFeedback = async (e) => {
    e.preventDefault();

    if (!feedbackText.trim()) {
      setFeedbackMessage("Please write your feedback before submitting.");
      return;
    }

    setFeedbackSending(true);
    setFeedbackMessage("");

    try {
      const resp = await fetch(`${backend_url}/submit-feedback/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          feedback: feedbackText,
        }),
      });

      let data = {};
      try {
        data = await resp.json();
      } catch {}

      if (!resp.ok) {
        setFeedbackMessage(
          data?.detail ||
            "❌ Failed to submit feedback. Please try again."
        );
      } else {
        setFeedbackMessage("✅ Thank you! Your feedback has been submitted.");
        setFeedbackText("");
      }
    } catch (e) {
      setFeedbackMessage("❌ Failed to submit feedback. Please try again.");
    } finally {
      setFeedbackSending(false);
    }
  };

  return (
    <div
      className="register-container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "10px",
        backgroundImage: `url(${logo3})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
      }}
    >
      <div
        className="register-card"
        style={{
          width: "100%",
          maxWidth: 520,
          margin: "24px 16px",
          minHeight: 260,
          display: "flex",
          flexDirection: "column",
          borderRadius: 18,
          padding: 24,
          boxShadow: "0 18px 45px rgba(0,0,0,0.4)",
        }}
      >
        {/* Header */}
        <div
          className="register-header"
          style={{ marginBottom: 12, textAlign: "center" }}
        >
          <h2
            className="register-title"
            style={{
              fontSize: "24px",
              marginBottom: 4,
              color: "#f9fafb",
              fontWeight: 700,
            }}
          >
            HREXORA Campus Connection
          </h2>
          <p style={{ fontSize: 14, color: "#d1d5db", margin: 0 }}>
            We value your experience. Please share your feedback with us.
          </p>
        </div>

        {/* FEEDBACK FORM */}
        <form
          onSubmit={handleSubmitFeedback}
          style={{
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            marginTop: 4,
          }}
        >
          <label
            style={{
              fontWeight: 600,
              alignSelf: "flex-start",
              color: "#e5e7eb",
              fontSize: 14,
              marginBottom: 6,
            }}
          >
            Your Feedback
          </label>

          <textarea
            rows={5}
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
            placeholder="Write your suggestions ..."
            style={{
              width: "95%",
              marginTop: 2,
              padding: "10px 12px",
              border: "1px solid #4b5563",
              color: "#f9fafb",
              background: "rgba(8, 28, 58, 0.9)",
              fontSize: 14,
              resize: "vertical",
              outline: "none",
            }}
          />

          {/* Button */}
          <button
            type="submit"
            disabled={feedbackSending}
            style={{
              marginTop: 14,
              padding: "12px 16px",
              width: "70%",
              maxWidth: 220,
              borderRadius: 8,
              background: "linear-gradient(45deg, #2563eb, #27dba1)",
              color: "white",
              fontWeight: 700,
              fontSize: 18,
              border: "none",
              cursor: feedbackSending ? "not-allowed" : "pointer",
              textAlign: "center",
              letterSpacing: "1px",
              fontFamily: '"Rajdhani", sans-serif',
              boxShadow: "0 6px 0 #0f4fa8",
              transition: "transform 0.15s ease, box-shadow 0.15s ease",
            }}
            onMouseOver={(e) => {
              if (!feedbackSending) {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 8px 0 #0c3f84";
              }
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 6px 0 #0f4fa8";
            }}
          >
            {feedbackSending ? "Submitting..." : "Submit Feedback"}
          </button>

          {feedbackMessage && (
            <div
              style={{
                marginTop: 10,
                color: "#e5e7eb",
                textAlign: "center",
                width: "100%",
                fontSize: 13,
              }}
            >
              {feedbackMessage}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
